export const API_BASE_URL = 'https://shravanth007-lemnisca-assignment-ba.vercel.app';

export const STORAGE_KEYS = {
  MESSAGES: 'chatMessages',
  SESSION_ID: 'sessionId'
};

export const SUGGESTIONS = [
  "What are the differences between the Pro and Enterprise plans?",
  "How do I set up a webhook integration?",
  "What is the PTO and leave policy?"
];

export const UI_TEXT = {
  TITLE: "ClearPath Support",
  SUBTITLE: "How can we help you with ClearPath today?",
  SUGGESTIONS_LABEL: "Suggestions on what to ask Our AI",
  INPUT_PLACEHOLDER: "Ask me anything about ClearPath…",
  LOADING_TEXT: "Typing...",
  FOOTER_MESSAGE: "Conversations may be recorded to improve AI performance.",
  USER_LABEL: "YOU",
  ASSISTANT_LABEL: "CLEARPATH AI",
  NEW_CONVERSATION_TOOLTIP: "New conversation"
};
